import type {EmptyCellValueMode} from '../types/Api';

/** Applied when a preset's settings predate the emptyCellValueMode field. */
export const DEFAULT_EMPTY_CELL_VALUE_MODE: EmptyCellValueMode = 'NOTHING';
